<div class="comment">
  <div class="comment-heading">
    <div class="comment-header-image"><div *ngIf="!comment.user.picture" class="avatar-icon" [style]="'background-color:'+color | safeStyle">{{comment.user.username[0]}}</div><img  class="avatar-icon" *ngIf="comment.user.picture" [src]="comment.user.picture | safe" onError="comment.user.picture = ''"/></div>
    <div class="comment-header-button" [title]="!comment.resolved ? 'Mark as Resolved' : 'Reopen Comment'" (click)="resolve(comment)"><i class="fas fa-check" *ngIf="!comment.resolved"></i><i class="fas fa-box-open" *ngIf="comment.resolved"></i></div>
      <div class="comment-user">{{comment.user.username}}</div>
      <div class="comment-time">{{comment.time|localizeDate:'medium'}}</div>
    </div>
  <div class="comment-body">
    <div *ngIf="comment.selection">
      <div class="comment-selection-title">{{'comment_selection'| translation}}:</div>
      <div class="comment-selection-display" [innerHtml]="comment.selection | safeHtml"></div>
    </div>
   <div [innerHTML]="comment.text | safeHtml"></div>
  </div>
</div>

